import jwtDecode from 'jwt-decode';
import store from 'store';

var getHash = function getHash() {
  return window.location.hash.substring(1);
};

var clearHash = function clearHash() {
  if (window.history.replaceState) {
    history.replaceState({}, document.title, '.');
  } else {
    window.location.hash = '';
  }
};

var redirectTo = function redirectTo(url) {
  window.location.href = url;
};

var createElement = function createElement(tagName) {
  return document.createElement(tagName);
};

var appendToBody = function appendToBody(element) {
  return document.body.appendChild(element);
};

var isInIframe = function isInIframe() {
  return window.self !== window.top;
};

var sendParentMessage = function sendParentMessage(message) {
  return parent.postMessage(message, '*');
};

var listenForMessages = function listenForMessages(iframe, eventListener) {
  var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  var eventer = window[eventMethod];
  var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

  eventer(messageEvent, eventListener, false);
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};













var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};







var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var generateNonce = function generateNonce() {
  return new Date().getTime() * Math.random();
};

var buildRedirectUrl = function buildRedirectUrl(_ref) {
  var tenant = _ref.tenant,
      clientId = _ref.clientId,
      responseType = _ref.responseType,
      redirectUri = _ref.redirectUri,
      scope = _ref.scope,
      responseMode = _ref.responseMode,
      state = _ref.state,
      resource = _ref.resource,
      _ref$nonce = _ref.nonce,
      nonce = _ref$nonce === undefined ? generateNonce() : _ref$nonce;

  var url = 'https://login.microsoftonline.com/' + tenant + '/oauth2/v2.0/authorize' + ('?client_id=' + clientId) + ('&response_type=' + responseType) + ('&redirect_uri=' + redirectUri) + ('&scope=' + scope) + ('&response_mode=' + responseMode);

  if (state) {
    url += '&state=' + state;
  }

  if (resource) {
    url += '&resource=' + resource;
  }

  url += '&nonce=' + nonce;

  return url;
};

var redirectToLogin = function redirectToLogin(options) {
  redirectTo(buildRedirectUrl(_extends({}, getAzureConfig(), options)));
};

var parseJwt = function parseJwt(jwtString) {
  try {
    return jwtDecode(jwtString);
  } catch (err) {
    return undefined;
  }
};

var isValidJwt = function isValidJwt(jwtString) {
  return !!parseJwt(jwtString);
};

var user = void 0;

var getUser = function getUser() {
  return user;
};
var setUser = function setUser(accessToken) {
  user = parseJwt(accessToken);
  return user;
};

var TOKEN_STORE = 'token';

var isValidAccessToken = function isValidAccessToken(accessToken) {
  return isValidJwt(accessToken);
};

var getToken = function getToken() {
  return store.get(TOKEN_STORE);
};

var storeToken = function storeToken(token) {
  return store.set(TOKEN_STORE, token);
};

var clearToken = function clearToken() {
  return store.remove(TOKEN_STORE);
};

var TIMEOUT = 10000;

var buildRefreshUrl = function buildRefreshUrl(_ref) {
  var loginHint = _ref.loginHint,
      _ref$domainHint = _ref.domainHint,
      domainHint = _ref$domainHint === undefined ? 'organizations' : _ref$domainHint,
      _ref$prompt = _ref.prompt,
      prompt = _ref$prompt === undefined ? 'none' : _ref$prompt,
      config = objectWithoutProperties(_ref, ['loginHint', 'domainHint', 'prompt']);

  var url = buildRedirectUrl(config);
  return url + '&login_hint=' + loginHint + '&domain_hint=' + domainHint + '&prompt=' + prompt;
};

var getPreferredUsername = function getPreferredUsername() {
  return getUser().upn;
};

var createIframe = function createIframe() {
  var iframe = createElement('iframe');
  iframe.src = buildRefreshUrl(_extends({}, getAzureConfig(), {
    loginHint: getPreferredUsername()
  }));
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'hidden';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.borderWidth = '0px';

  return iframe;
};

var removeIframe = function removeIframe(iframe) {
  iframe.parentNode.removeChild(iframe);
};

var isRefreshMessage = function isRefreshMessage(data) {
  return !!(data.access_token || data.error);
};

var implicitRefresh = function implicitRefresh() {
  var iframe = void 0;
  var timeout = void 0;

  return new Promise(function (resolve, reject) {
    iframe = createIframe();

    listenForMessages(iframe, function (_ref2) {
      var data = _ref2.data;

      if (isRefreshMessage(data)) {
        clearTimeout(timeout);

        if (data.error) {
          clearToken();
          reject(data);
        }

        resolve(data);
      }
    });

    appendToBody(iframe);

    timeout = setTimeout(function () {
      clearToken();
      reject({ error: 'Timeout', error_description: 'Silent token refresh timed out' });
    }, TIMEOUT);
  }).then(function (data) {
    removeIframe(iframe);
    return data;
  }).catch(function (err) {
    removeIframe(iframe);
    throw err;
  });
};

var isTokenRefresh = function isTokenRefresh() {
  return !!(isInIframe() && getHash().match(/(access_token|error)=/g));
};

var decorateRefreshHandler = function decorateRefreshHandler(tokenRefreshHandler) {
  if (typeof tokenRefreshHandler !== 'function') {
    throw new Error('Token Refresh Handler must be a function.');
  }

  return function () {
    return tokenRefreshHandler().then(function (response) {
      return storeToken(response);
    });
  };
};

var parseTokenFromHash = function parseTokenFromHash() {
  var hash = getHash();

  if (!hash) {
    return undefined;
  }

  var params = hash.split('&');

  var token = params.reduce(function (total, current) {
    var _babelHelpers$extends;

    var _current$split = current.split('='),
        _current$split2 = slicedToArray(_current$split, 2),
        param = _current$split2[0],
        value = _current$split2[1];

    return _extends({}, total, (_babelHelpers$extends = {}, _babelHelpers$extends[param] = value, _babelHelpers$extends));
  }, {});

  return token;
};

var initTokenRefresh = function initTokenRefresh() {
  var token = parseTokenFromHash();

  if (token) {
    storeToken(token);
    sendParentMessage(token);
  }

  return token;
};

var azureConfig = {
  tenant: 'common',
  responseType: 'id_token+token',
  scope: 'openid+User.Read',
  responseMode: 'fragment',

  onTokenRefresh: implicitRefresh,
  onTokenParse: function onTokenParse() {
    var token = parseTokenFromHash();
    clearHash();
    return token;
  }
};

var getAzureConfig = function getAzureConfig() {
  return azureConfig;
};
var setAzureConfig = function setAzureConfig(config) {
  if (!config.clientId || !config.redirectUri) {
    throw new Error('Client ID and Redirect URI must be present.');
  }

  azureConfig = _extends({}, azureConfig, config);

  if (config.onTokenRefresh) {
    azureConfig.onTokenRefresh = decorateRefreshHandler(config.onTokenRefresh);
  }

  return azureConfig;
};

var loadToken = function loadToken() {
  var token = getToken();

  if (!token) {
    token = getAzureConfig().onTokenParse();

    if (!token || !isValidAccessToken(token.access_token)) {
      return undefined;
    }

    storeToken(token);
  }

  setUser(token.access_token);
  return token;
};

var init$1 = function init(azureConfig) {
  setAzureConfig(azureConfig);
  var refresh = isTokenRefresh();
  var token = refresh ? initTokenRefresh() : loadToken();

  return {
    refresh: refresh,
    token: token
  };
};

var getAuthHeaders = function getAuthHeaders() {
  var _getToken = getToken(),
      token = _getToken.id_token;

  return {
    Authorization: 'Bearer ' + token
  };
};

var createRequest = function createRequest(endpoint, _ref) {
  var body = _ref.body,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method,
      headers = _ref.headers,
      _ref$mode = _ref.mode,
      mode = _ref$mode === undefined ? 'cors' : _ref$mode;
  return fetch(endpoint, {
    body: (typeof body === 'undefined' ? 'undefined' : _typeof(body)) === 'object' ? JSON.stringify(body) : body,
    method: method,
    mode: mode,
    headers: _extends({
      'Content-Type': 'application/json'
    }, getAuthHeaders(), headers)
  });
};

var authorisedFetch = function authorisedFetch(endpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createRequest(endpoint, options).then(function (response) {
    if (response.status === 401) {
      return getAzureConfig().onTokenRefresh().then(function () {
        return createRequest(endpoint, options);
      });
    }
    return response;
  });
};

export { storeToken, getToken, isValidAccessToken, clearToken, getAzureConfig, setAzureConfig, getUser, setUser, buildRedirectUrl, redirectToLogin, createIframe, buildRefreshUrl, isTokenRefresh, implicitRefresh, removeIframe, getPreferredUsername, isRefreshMessage, decorateRefreshHandler, getAuthHeaders, authorisedFetch, initTokenRefresh, parseTokenFromHash };export default init$1;



//////////////////
// WEBPACK FOOTER
// ./~/colleague-auth/dist/index.js
// module id = 124
// module chunks = 0